import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit {

  year: number = (new Date()).getFullYear();
  
  
  // unique for footer and header
  wwwContent: string = 'www.';

  constructor() { }

  ngOnInit() {
  }

}
